export enum RenewalTopFilter {
  SearchFilter = 'searchFilter',
}

export type RenewalTopFiltersProps = {
  availableFilters: RenewalTopFilter[];
  onFilterChangeHandler: (value: string, filterType: RenewalTopFilter) => void;
  filters: Record<RenewalTopFilter, string>;
};
